var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOfferErrorBadge = function SvgOfferErrorBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.138 8.465 4.387 35.243a1 1 0 0 0 .861 1.507h31.504a1 1 0 0 0 .861-1.507L21.863 8.465a1 1 0 0 0-1.724 0Z",
    fill: "#E14851",
    stroke: "#E14851",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5V28",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31.5,
    r: 1.75,
    fill: "#fff"
  })));
};

export { SvgOfferErrorBadge as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMC4xMzgxIDguNDY1MjlMNC4zODY1MSAzNS4yNDNDMy45OTQzOCAzNS45MDk2IDQuNDc1MDMgMzYuNzUgNS4yNDg0NSAzNi43NUgzNi43NTE2QzM3LjUyNSAzNi43NSAzOC4wMDU3IDM1LjkwOTYgMzcuNjEzNSAzNS4yNDNMMjEuODYyIDguNDY1MjlDMjEuNDc1MyA3LjgwNzk4IDIwLjUyNDcgNy44MDc5OCAyMC4xMzgxIDguNDY1MjlaIiBmaWxsPSIjRTE0ODUxIiBzdHJva2U9IiNFMTQ4NTEiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBkPSJNMjEgMTcuNVYyOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPGNpcmNsZSBjeD0iMjEiIGN5PSIzMS41IiByPSIxLjc1IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";